import { Paper, FormControl, Button, InputLabel, MenuItem, Select, TextField} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import {DataGrid} from "@mui/x-data-grid";
import { searchTrips, fetchEmployees, searchpassiveTrips, searchTripsbyStartDate } from "../api/customerapi";
import DateCalc from "./date";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
        width: theme.spacing(30),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign:"left"
      },
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(18),
        height: theme.spacing(5),
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(1),
        fontSize: 14
      },
      
  }));

const Searchtrip = () => {

    const classes = useStyles();

    const width = window.innerWidth-200;
//console.log(width);
const columns = [
  { field: 'trip_id', 
  headerName: ' Trip ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  {
    field: 'cust_name',
    headerName: 'Name',
    width: width/12*3,
    
  },
  {
    field: 'primary_destination',
    headerName: 'Destination',
    width: width/12*2,
  },
  {
    field: 'trip_owner',
    headerName: 'Trip Owner',
    width: width/12,
  },
  {
    field: 'quote_ids',
    headerName: 'Quote IDs',
    width: width/12*2,
  },
  {
    field: 'createdAt',
    headerName: 'Created On',
    width: width/12*2,
  },
  {
    field: 'trip_status',
    headerName: 'Trip Status',
    width: width/12*2,
        /*valueGetter: (params) =>
      `${params.getValue(params.id, 'firstName') || ''} ${
        params.getValue(params.id, 'lastName') || ''
      }`,*/
  },
];

const columns2 = [
  { field: 'trip_id', 
  headerName: ' Trip ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  {
    field: 'cust_name',
    headerName: 'Name',
    width: width/12*4,
    
  },
  {
    field: 'primary_destination',
    headerName: 'Destination',
    width: width/12*2,
  },
  {
    field: 'trip_owner',
    headerName: 'Trip Owner',
    width: width/12,
  },
  
  {
    field: 'updatedAt',
    headerName: 'Updated On',
    width: width/12*2,
  },
  {
    field: 'trip_status',
    headerName: 'Trip Status',
    width: width/12*2,
        /*valueGetter: (params) =>
      `${params.getValue(params.id, 'firstName') || ''} ${
        params.getValue(params.id, 'lastName') || ''
      }`,*/
  },
];

const columns3 = [
  { field: 'trip_id', 
  headerName: ' Trip ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
  {
    field: 'cust_name',
    headerName: 'Name',
    width: width/12*2,
    
  },
  {
    field: 'primary_destination',
    headerName: 'Destination',
    width: width/12*2,
  },
  {
    field: 'trip_owner',
    headerName: 'Trip Owner',
    width: width/12,
  },
  
  {
    field: 'updatedAt',
    headerName: 'Updated On',
    width: width/12*2,
  },
  {
    field: 'startdate',
    headerName: 'Start Date',
    width: width/12*2,
  },
  {
    field: 'trip_status',
    headerName: 'Trip Status',
    width: width/12*2,
        /*valueGetter: (params) =>
      `${params.getValue(params.id, 'firstName') || ''} ${
        params.getValue(params.id, 'lastName') || ''
      }`,*/
  },
];

    const [searchData, setsearchData]=useState([{
        
    }]);
    const [searchData2, setsearchData2]=useState([{
        
    }]);
    const [searchData3, setsearchData3]=useState([{
        
    }]);
    const [emp, setemp]=useState([])
    const [listtripData, setlisttripData]=useState([{
          
          
      start_date_undecided: "No",
      quote:[],
      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt:"",
      trip_owner:"",
      status_history:[],
      follow_up:[{
          status: "Open",
          notes: "",
      }],
    }]); 
    
    const [listtripData2, setlisttripData2]=useState([{
          
          
      start_date_undecided: "No",
      quote:[],
      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt:"",
      trip_owner:"",
      status_history:[],
      follow_up:[{
          status: "Open",
          notes: "",
      }],
    }]);

    const [listtripData3, setlisttripData3]=useState([{
          
          
      start_date_undecided: "No",
      quote:[],
      primary_destination: "",
      number_adults: 2,
      number_child: 0,
      type_of_vacation: "Honeymoon",
      duration: 4,
      trip_stage: "Plan in progress",
      trip_channel: "Unknown",
      trip_requirements: "",
      trip_campaign: "",
      multi_destinations: "No",
      secondary_destinations: "",
      trip_status: "",
      createdAt:"",
      trip_owner:"",
      status_history:[],
      follow_up:[{
          status: "Open",
          notes: "",
      }],
    }]);
      
    const getEmployees = async () => {
      try{
      const data = await fetchEmployees();
      //const custdatalistfromdb= data.data
  
      const empsplist = data.data.filter((emp) => emp.role == "Sales" || emp.role == "SME");
      const empshortname = empsplist.map((emp) => emp.short_name);
      setemp(empshortname);
    }catch(err){
      console.log(err)
    }
    };

    useEffect(() => {
      
      getEmployees()
  }, [])
      //console.log(searchData2)
      const handleSearch = async (e) => {
        try{
          if(searchData.data && searchData.start_date && searchData.end_date){
        const data = await searchTrips(searchData.data, searchData.start_date, searchData.end_date);
           
        setlisttripData(data.data)
          }else{
            alert("Please enter all parameters -owner, start date and end date before search")
          }
        }catch(err){
          console.log(err)
        }
      }

      const handleSearch2 = async (e) => {
        try{
        if(searchData2.statusdata && searchData2.empdata && searchData2.start_date && searchData2.end_date){
      const data = await searchpassiveTrips(searchData2.statusdata, searchData2.empdata, searchData2.start_date, searchData2.end_date);
         
      setlisttripData2(data.data)
      //console.log(listtripData2)
      // console.log(tripdatalistdisplay2)
        }else{
          alert("Please enter all parameters -owner, start date and end date before search")
        }
      }catch(err){
        console.log(err)
      }
    }

    const handleSearch3 = async (e) => {
      try{
      if(searchData3.start_date && searchData3.end_date){
    const data = await searchTripsbyStartDate(searchData3.start_date, searchData3.end_date);
       
    setlisttripData3(data.data)
    console.log(listtripData3)
    // console.log(tripdatalistdisplay2)
      }else{
        alert("Please enter all parameters -start date and end date before search")
      }
    }catch(err){
      console.log(err)
    }
  }

      const tripdatalistdisplay=listtripData.map(tripdata=>({cust_name: tripdata.cust_name, 
        id:listtripData.indexOf(tripdata), 
        trip_id:tripdata.trip_id, 
        primary_destination:tripdata.primary_destination, 
        trip_owner:tripdata.trip_owner,
        trip_status: tripdata.trip_status,
        quote_ids:tripdata.quote.toString(),
        createdAt:tripdata.createdAt.slice(0,10) }));
        
        const tripdatalistdisplay2=listtripData2.map(tripdata=>({cust_name: tripdata.cust_name, 
          id:listtripData2.indexOf(tripdata), 
          trip_id:tripdata.trip_id, 
          primary_destination:tripdata.primary_destination, 
          trip_owner:tripdata.trip_owner,
          
          trip_status: tripdata.trip_status,
          updatedAt:tripdata.updatedAt?.slice(0,10) }));

          const tripdatalistdisplay3=listtripData3.map(tripdata=>({cust_name: tripdata.cust_name, 
            id:listtripData3.indexOf(tripdata), 
            trip_id:tripdata.trip_id, 
            primary_destination:tripdata.primary_destination, 
            trip_owner:tripdata.trip_owner,
            startdate:String(tripdata.trip_start_date).split("T").slice(0,1),
            trip_status: tripdata.trip_status,
            updatedAt:tripdata.updatedAt?.slice(0,10) }));

          

        const gridcellclick=(id)=>{
          window.open("/tripdataentry/" + id, '_blank');
            //console.log("/custdataentry/"+id);
          }

    return ( 
      <div>
<Paper variant="outlined" className={classes.paper} elevation={10}>        
           
           <div align="center">
               <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
               <InputLabel id="trip owner">Trip Owner</InputLabel>
                   <Select displayEmpty className={classes.textField} labelId="Trip Owner"  onChange={(e)=> setsearchData2({...searchData2, empdata: e.target.value})}>
                   {emp.map((emp) => {
                   return <MenuItem value={emp}>{emp}</MenuItem>;
                 })}
                   
                   </Select>
                   </FormControl>
                   <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
               <InputLabel id="trip status">Trip Status</InputLabel>
                   <Select displayEmpty className={classes.textField} labelId="Trip Status"  onChange={(e)=> setsearchData2({...searchData2, statusdata: e.target.value})}>
                  
                 <MenuItem value={"Closed"}>Closed</MenuItem>
                
                 <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                 
                 <MenuItem value={"Booked Outside"}>Booked Outside</MenuItem>
                 <MenuItem value={"Dropped After Booking"}>
                   Dropped After Booking
                 </MenuItem>
                   
                   </Select>
                   </FormControl>
                   <TextField variant="outlined"  type="date" label="Updated On or after"  className={classes.textField}  InputLabelProps={{ shrink: true }} onChange={(e)=> setsearchData2({...searchData2, start_date: e.target.value})}/>
                   <TextField variant="outlined"  type="date" label="Updated On or before"  className={classes.textField}  InputLabelProps={{ shrink: true }} onChange={(e)=> setsearchData2({...searchData2, end_date: e.target.value})}/>
                   {/* <Button onClick={() => setsearchData2({start_date: DateCalc(0), end_date:DateCalc(1), statusdata:"Cancelled"})} color="secondary" variant="contained" className={classes.button}>Today Cancelled</Button> */}
               <Button onClick={handleSearch2} color="secondary" variant="contained" className={classes.button}>Search</Button>
           </div>    
   
           {tripdatalistdisplay2.length >0 ?
           <div style={{ height: 1200, width: '100%' }}>
           <DataGrid rows={tripdatalistdisplay2} 
           onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
           columns={columns2}
           autoPageSize
          //  pageSize={20}
           
          //  autoHeight
           >      
         </DataGrid>      
       </div>   :
       <div align="center"><h1>No data found</h1></div>    }    
       </Paper>

        <Paper variant="outlined" className={classes.paper} elevation={10}>        
           
        <div align="center">
            <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="trip owner">Trip Owner</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Trip Owner"  onChange={(e)=> setsearchData({...searchData, data: e.target.value})}>
                {emp.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
                
                </Select>
                </FormControl>
               
                <TextField variant="outlined"  type="date" label="Created On or after"  className={classes.textField}  InputLabelProps={{ shrink: true }} onChange={(e)=> setsearchData({...searchData, start_date: e.target.value})}/>
                <TextField variant="outlined"  type="date" label="Created On or before"  className={classes.textField}  InputLabelProps={{ shrink: true }} onChange={(e)=> setsearchData({...searchData, end_date: e.target.value})}/>
            <Button onClick={handleSearch} color="secondary" variant="contained" className={classes.button}>Search</Button>
        </div>    

        {tripdatalistdisplay.length >0 ?
        <div style={{ height: 1200, width: '100%' }}>
        <DataGrid rows={tripdatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
        columns={columns}
        autoPageSize
        // pageSize={20}
        
        // autoHeight
        >      
      </DataGrid>      
    </div>   :
    <div align="center"><h1>No data found</h1></div>    }    
    </Paper>

    <Paper variant="outlined" className={classes.paper} elevation={10}>        
           
        <div align="center">
               
                <TextField variant="outlined"  type="date" label="Start Date On or after"  className={classes.textField}  InputLabelProps={{ shrink: true }} onChange={(e)=> setsearchData3({...searchData3, start_date: e.target.value})}/>
                <TextField variant="outlined"  type="date" label=" Start Date On or before"  className={classes.textField}  InputLabelProps={{ shrink: true }} onChange={(e)=> setsearchData3({...searchData3, end_date: e.target.value})}/>
            <Button onClick={handleSearch3} color="secondary" variant="contained" className={classes.button}>Search</Button>
        </div>    

        {tripdatalistdisplay3.length >0 ?
        <div style={{ height: 1200, width: '100%' }}>
        <DataGrid rows={tripdatalistdisplay3} 
        onCellDoubleClick={(getValue)=>gridcellclick(getValue.row.trip_id)}
        columns={columns3}
        autoPageSize
        // pageSize={20}
        
        // autoHeight
        >      
      </DataGrid>      
    </div>   :
    <div align="center"><h1>No data found</h1></div>    }    
    </Paper>
    
    </div>
     );
}
 
export default Searchtrip;